import { LoadingIndicator, TwoSwitch }          from "../lib/iprs-react-library/src/index.js";
import ContactInformation                       from "./ContactInformation";
import sanitizeHtml         from 'sanitize-html';
import { useEffect, useState }                  from "react";
import ButtonHolder                             from "../lib/iprs-react-library/src/Form/ButtonHolder";

const clientDomainAndNameFilter = new RegExp(process.env.REACT_APP_CLIENT_NAME_AND_DOMAIN_FILTER ?? ".*");
const domain = window.location.hostname;

const VitalityHealthLiteMH = 579490;
const VitalityHealthLiteMSK = 579491;

const ReferralClientList = ({api, selectReferrer}) => {

	const [err, setErr] = useState(null);

    const [referrerDetails, setReferrerDetails] = useState(null);

    const [showingWarning, setShowingWarning] = useState(false);
    const [selectedClient, setSelectedClient] = useState(null);

    useEffect(()=>{

        // we do receive duplicate party IDs
        const removeDuplicateParties = clients =>
            clients.reduce((acc, curr) => {
                if(!acc.ids.includes(curr.PartyID)){
                    return { ids: [...acc.ids,curr.PartyID], result: [...acc.result, curr] };
                }else{
                    return acc;
                }
            }, { ids: [], result: [] } ).result;

        api.transact("GetReferrerDetails", {})
            .then(r => r.apiResult)
            .then(r => r.ClientList)
            .then(r => r.filter(c => clientDomainAndNameFilter.test(`domain='${domain}' client='${c.Name}'`)))
            .then(r => removeDuplicateParties(r) )
            .then(r => r.sort((c1, c2) => c1.Name?.localeCompare(c2.Name)))
            .then(r => setReferrerDetails(r))
            .catch(err => setErr(err.message));
    }, [api, setReferrerDetails]);

    const getWelcomeText = () => {
        /* This replaces <div ng-bind-html="trustHTML(ClientList[0].WelcomeText)"></div> in the
        angular version of this site. It works when the referrer has a limited set of clients
        who all share the same welcome text */
        const welcomeText = referrerDetails?.find(r => ('string' === typeof r?.WelcomeText) && 0 < r?.WelcomeText.trim().length )?.WelcomeText;
        return welcomeText? sanitizeHtml(welcomeText) : null;
    };
    const welcomeText = getWelcomeText();

    const handleClientClick = (clientReferralDetails) => {
        const isLiteClient = clientReferralDetails.PartyID === VitalityHealthLiteMH ||
                            clientReferralDetails.PartyID === VitalityHealthLiteMSK;

        if (isLiteClient) {
            setSelectedClient(clientReferralDetails);
            setShowingWarning(true);
        } else {
            selectReferrer(clientReferralDetails);
        }
    };

    const handleWarningConfirm = () => {
        setShowingWarning(false);
        if (selectedClient) {
            selectReferrer(selectedClient);
        }
    };

    const handleWarningCancel = () => {
        setShowingWarning(false);
        setSelectedClient(null);
    };

    return <>
        <TwoSwitch test={null === referrerDetails} >
            <LoadingIndicator loading={!err} />
            <TwoSwitch test={0 < referrerDetails?.length} >
                <div style={{display: 'contents'}}>
                    {welcomeText && <div
                    style={{fontWeight: 'bold', marginBottom: '3em', marginTop: '1em'}}
                    dangerouslySetInnerHTML={{ __html: welcomeText }} /> }
                    <ul className="referrerListStyle" >
                        {referrerDetails?.map(r => <Li clientReferralDetails={r}
                        key={r.PartyID} selectReferrer={handleClientClick}/>)}
                    </ul>
                </div>
                <p>Sorry there are no IPRS clients for whome you Can
                    submit referrals.
                </p>
            </TwoSwitch>
        </TwoSwitch>
        <TwoSwitch test={err} >
            {err}
        </TwoSwitch>

        {showingWarning && <SelectWarning
            onConfirm={handleWarningConfirm}
            onCancel={handleWarningCancel}
        />}

        <ContactInformation />
    </>;
}

const Li = ({clientReferralDetails, selectReferrer}) => {
    return <li>
            <a href=''
            referrer-name={clientReferralDetails.Name}
            name={clientReferralDetails.Name}
            value={clientReferralDetails.PartyID}
            onClick={e => {e.preventDefault(); selectReferrer(clientReferralDetails)}}>{clientReferralDetails.Name}</a>
        </li>
}

const SelectWarning = ({onConfirm, onCancel}) => (
    <div className="warning-overlay">
        <div className="warning-popup">
            <div className="warning-content">
                Before submitting the referral, please check you've selected the
                correct plan type.
            </div>
            <ButtonHolder action={onConfirm} enabled={true}
                actionTxt={"OK"} cancelTxt={"Cancel"} cancel={onCancel} />
        </div>
    </div>
);

export default ReferralClientList; 